import Cookies from "js-cookie";

const storeAsSecureCookie = (name: any, val: any) => Cookies.set(name, val, { sameSite: "lax" });
export default storeAsSecureCookie;
